import { useContext } from "react"
import AppInfoContext from "src/provider/state-manager/appInfoProvider"

function SvgComponent(props: any) {
    const {info: {theme}} = useContext(AppInfoContext)

    return (
        <svg
            width={32}
            height={30}
            viewBox="0 0 32 30"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
        <rect x={0.5} y={0.5} width={30.0549} height={29} rx={14.5} fill="#fff" />
        <rect
            x={0.5}
            y={0.5}
            width={30.0549}
            height={29}
            rx={14.5}
            stroke={theme["#0EA59D"]}
        />
        <path
            d="M21.757 17.441c-.274.263-.4.652-.336 1.021l.936 5.179c.074.442-.105.883-.474 1.137a1.157 1.157 0 01-1.232.084L15.99 22.43a1.195 1.195 0 00-.527-.137h-.285a.855.855 0 00-.284.094L10.23 24.83c-.232.116-.495.158-.747.116a1.17 1.17 0 01-.937-1.338l.937-5.178a1.18 1.18 0 00-.336-1.03l-3.8-3.685a1.137 1.137 0 01-.284-1.19c.137-.41.494-.716.936-.789l5.231-.759c.4-.042.747-.283.926-.64l2.305-4.727c.053-.105.127-.2.212-.284l.094-.073c.042-.054.105-.095.17-.137l.114-.042L15.23 5h.443c.4.042.747.283.926.63l2.336 4.706c.168.348.494.58.873.641l5.232.76c.442.063.811.368.957.789.137.42.021.884-.305 1.19l-3.936 3.725z"
            fill={theme["#0D968F"]}
        />
        </svg>
    )
}
  
  export default SvgComponent